const formatDate = (iso: string) => new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' }).format(new Date(iso))

export function ArticleMetadata({ publisher, publishedAt }: { publisher: string; publishedAt: string }) {
  return <div className="news-card-meta"><span>{publisher}</span><time dateTime={publishedAt}>{formatDate(publishedAt)}</time></div>
}
